(() => {
  if (window.icePhase50Analytics) return;
  const measurementId = 'G-TFVEHJKHBV';
  const allowedFields = new Set(['tool_name', 'calculator', 'control', 'destination', 'journey_type', 'journey_name', 'section', 'link_type', 'form_id']);
  function permitted() {
    try {
      return window.Shopify?.designMode !== true && !['unpublished', 'development'].includes(String(window.Shopify?.theme?.role || '').toLowerCase()) && !new URLSearchParams(location.search).has('preview_theme_id') && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch (_) {
      return false;
    }
  }
  function track(name, detail = {}) {
    if (!permitted()) return false;
    const payload = { send_to: measurementId, page_path: location.pathname };
    for (const [key, value] of Object.entries(detail)) {
      if (allowedFields.has(key) && typeof value === 'string') payload[key] = value.slice(0, 100);
    }
    if (typeof window.gtag === 'function') window.gtag('event', name, payload);
    else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push((function () { return arguments; })('event', name, payload));
    }
    return true;
  }
  window.icePhase50Analytics = { track };
  const pendingKey = 'ice_phase50_contact_pending';
  function leadSuccess() {
    const success = document.querySelector('[data-ice-lead-success]');
    if (!success || success.dataset.tracked) return;
    try {
      if (sessionStorage.getItem(pendingKey) !== success.dataset.iceLeadSuccess) return;
      let attribution = {};
      try {
        const saved = JSON.parse(sessionStorage.getItem('ice_phase62_tool_context'));
        const allowed = ['coffee_machine_group_size_finder', 'dishwasher_capacity_finder', 'ice_machine_size_finder'];
        if (saved?.expires > Date.now() && allowed.includes(saved.calculator)) attribution.calculator = saved.calculator;
      } catch (_) {}
      if (track('generate_lead', Object.assign({ form_id: success.dataset.iceLeadSuccess }, attribution))) {
        success.dataset.tracked = 'true';
        sessionStorage.removeItem(pendingKey);
        sessionStorage.removeItem('ice_phase62_sizing_brief');
        sessionStorage.removeItem('ice_phase62_tool_context');
      }
    } catch (_) {}
  }
  function loadPrivacy() {
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) leadSuccess(); });
    }
  }
  function mount() {
    loadPrivacy();
    leadSuccess();
  }
  function context(target) {
    const scope = target.closest('[data-buyer-solution], [data-brand-hub], [data-ice-buyer-journey], .ice-brands');
    if (!scope) {
      if (document.body.classList.contains('templateArticle') && target.closest('#main-content')) {
        return { journey_type: 'article', journey_name: location.pathname.split('/').pop(), section: target.closest('section[id]')?.id || 'article_body' };
      }
      return null;
    }
    return {
      journey_type: scope.hasAttribute('data-buyer-solution') ? 'buyer' : scope.hasAttribute('data-brand-hub') ? 'brand' : scope.hasAttribute('data-ice-buyer-journey') ? 'related' : 'brands_index',
      journey_name: scope.dataset.buyerSolution || scope.dataset.brandHub || scope.dataset.iceBuyerJourney || 'brands',
      section: target.closest('section[id]')?.id || 'hero'
    };
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || link.closest('.ice-tools, .ice-size')) return;
    const raw = link.getAttribute('href');
    const data = context(link);
    if (raw.startsWith('tel:')) {
      track('ice_phone_click', Object.assign({ destination: 'phone', link_type: 'phone' }, data));
      return;
    }
    if (raw.startsWith('mailto:')) {
      track('ice_email_click', Object.assign({ destination: 'email', link_type: 'email' }, data));
      return;
    }
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || raw.startsWith('#')) return;
    const path = url.pathname;
    const enquiry = /^\/pages\/(contact-us|request-for-quote|commercial-kitchen-design|service-request-form)\/?$/.test(path);
    if (!data && !enquiry) return;
    let kind = enquiry ? 'enquiry' : path.startsWith('/products/') ? 'product' : path.startsWith('/collections/') ? 'range' : path.startsWith('/blogs/') ? 'guide' : path.includes('/project-') || path === '/pages/our-projects' ? 'project' : /tools|calculator|finder/.test(path + url.hash) ? 'tool' : 'page';
    if (path === location.pathname && !url.search && !url.hash) return;
    track(enquiry ? 'ice_enquiry_click' : 'ice_buyer_journey_click', Object.assign({ destination: path, link_type: kind }, data));
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.id !== 'IceNativeContactForm' || !form.checkValidity()) return;
    try { sessionStorage.setItem(pendingKey, form.id); } catch (_) {}
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('visitorConsentCollected', mount);
  document.addEventListener('shopify:section:load', mount);
})();


